import http from '../util/request.js'

export const levelList = (params) =>{
	return http({
		url:'/apistore/level/levelList',
		data:params,
		method:'get'
	})
}
export const planList = (params) =>{
	return http({
		url:'/apistore/level/planList',
		data:params,
		method:'get'
	})
}
export const planOrderList = (params) =>{
	return http({
		url:'/apistore/level/planOrderList',
		data:params,
		method:'get'
	})
}


export const addPlanOrder = (params) =>{
	return http({
		url:'/apistore/storePlan/add',
		data:params,
		method:'post'
	})
}

